// components/PdfContent.js
import React from 'react';
import { Box, Divider, Stack, Typography ,Table, TableBody, TableRow, TableCell, TableContainer, Paper, TableHead,} from '@mui/material';
import PdfLayout from '../../components/pdfLayout';

export default function PdfFullPaymentInvoice({ data,refunded ,refundeAmount}) {

    // We wanted to let you know that we received your investment of (Commitment Amount) towards the Plot No. 120 project, which was successfully processed and approved. However, the (Refund amount )amount was subsequently refunded to your account due to [insert reason here – e.g., project cancellation, over-subscription, or manual refund request].
  return (
       <PdfLayout data={data}>
        <Box sx={{ mt: 2 }}>
          <Typography variant="body1">To</Typography>
          <Typography variant="body1">{data[0]?.investorName || "name"}</Typography>

            <Typography variant="body1" sx={{ mt: 2 }}>
                     We wanted to let you know that we received your investment of<strong> ₹{data[data.length-1]?.totalAmountPaid?.toLocaleString('en-IN')}</strong> towards the <strong>{data[0]?.propertyName}</strong>, which was successfully processed and approved. {refunded && ` However, the ${refundeAmount?.toLocaleString('en-IN')} amount was subsequently refunded to your account.`}
                   </Typography>

          <Box mt={2}>
            <Typography><strong>Asset ID</strong>: {data[0].propertyCode}</Typography>
            <Typography><strong>Total Commitment amount</strong>: ₹{data[0].amount.toLocaleString('en-IN')}</Typography>
          </Box>

          <TableContainer sx={{ mt: 2 }}>
            <Typography variant="h6" sx={{ p: 2 }}>Transaction Summary</Typography>
            <Table sx={{ border: '1px solid #e1e1e1', borderCollapse: 'collapse' }}>
              <TableHead>
                <TableRow>
                  <TableCell><strong>#</strong></TableCell>
                  <TableCell><strong>status</strong></TableCell>
                  <TableCell><strong>Amount { refunded?"Refunded":"Paid"}</strong></TableCell>
                  <TableCell><strong> { refunded?"Refund":"Payment"} Date</strong></TableCell>
                  <TableCell><strong>Approved Date</strong></TableCell>
                  <TableCell><strong>UTR</strong></TableCell>
                  

                </TableRow>
              </TableHead>
             <TableBody>
  {data.map((payment, index) => 
    ( <TableRow key={index}>
            <TableCell>{index + 1}</TableCell>
            <TableCell>
              {payment.status
                ? payment.status.charAt(0).toUpperCase() +
                  payment.status.slice(1).toLowerCase()
                : 'N/A'}
            </TableCell>
            <TableCell>₹{payment.amountByAdmin ? payment.amountByAdmin?.toLocaleString('en-IN') :payment.amountTransferred?.toLocaleString('en-IN')|| '0'}</TableCell>
            <TableCell>{payment.updated_at || 'N/A'}</TableCell>
            <TableCell>{payment.actionTaken || 'N/A'}</TableCell>
            <TableCell>{payment.refId || 'N/A'}</TableCell>
          </TableRow>)
  )}
</TableBody>

            </Table>
          </TableContainer>
          <Typography sx={{ mt: 2 }}>Regards,</Typography>
          <Typography>Team RealX</Typography>
        </Box>
      </PdfLayout>
  );
}
